export default __webpack_public_path__ + "static/media/user-profile-fill-icon.6795fb57.svg";